// extracted by mini-css-extract-plugin
module.exports = {"modalDialog":"styles__modalDialog___9bVs4"};